export default function FAQ() {
  const faqs = [
    {
      q: "What is a pandabuy spreadsheet used for?",
      a: "A pandabuy spreadsheet is a curated collection of product links and listings that shoppers use to discover trending fashion items, streetwear, sneakers, and accessories. It organizes verified finds from the pandabuy community into an easy-to-browse database, saving you hours of manual searching.",
    },
    {
      q: "Is using a pandabuy spreadsheet safe?",
      a: "Yes — when you use verified and community-reviewed spreadsheets. Our listed spreadsheets are regularly checked for quality and safety. We also provide guides on how to evaluate listings, check seller ratings, and avoid common pitfalls when shopping through pandabuy.",
    },
    {
      q: "How often are these spreadsheets updated?",
      a: "Update frequency varies by category. Sneaker spreadsheets are updated daily, while streetwear and luxury categories receive weekly updates. Budget and accessories spreadsheets are refreshed bi-weekly to monthly. Each category page shows its latest update schedule.",
    },
    {
      q: "What are the best spreadsheet categories?",
      a: "The most popular categories are streetwear (hoodies, tees, jackets), sneakers, and luxury items (bags, watches). Jersey and accessories categories are also growing rapidly. For beginners, we recommend starting with the streetwear or sneaker spreadsheets as they have the most verified listings.",
    },
    {
      q: "How do I start using a pandabuy spreadsheet?",
      a: "Getting started is simple — choose a category from our navigation menu, browse the spreadsheet listings, and click through to view items on pandabuy. Our beginner guide covers everything from account setup to placing your first order. No prior experience needed.",
    },
    {
      q: "Why use pandabuy.guru instead of searching directly?",
      a: "We save you time by organizing the best spreadsheet finds into one structured, searchable database. Instead of digging through forums, Reddit threads, and Discord servers, you get instant access to verified, regularly updated collections — all categorized and ready to browse.",
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-primary-100 text-primary-800 uppercase tracking-wider mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Frequently Asked{" "}
            <span className="text-primary-500">Questions</span>
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
              <summary className="px-5 py-4 cursor-pointer flex items-start justify-between gap-3 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-open:text-primary-600 transition-colors">
                  {faq.q}
                </h3>
                <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0 mt-0.5"></i>
                <i className="ri-subtract-line text-primary-500 hidden group-open:block flex-shrink-0 mt-0.5"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}